import { Select} from 'antd';
import React, { ReactElement, useState } from 'react';
import { convertToValidStr } from '../../../../utils/utility';
import { MAX_CHARACTERS_LIMIT, ONLY_ALPHA_NUMERIC } from '../../../constants/commonConstants';
import { useGetFormConfig } from '../../../hooks/useFormConfig';
import FormItem from '../FormItem/FormItem';
import './formSelect.less';

const { Option } = Select;

const FormSelect = (props: any): (ReactElement | null) => {
  const [searchValue, setSearchValue] = useState('');
  const [extraRules, setExtraRules] = useState<any[]>([]);

  const formConfig = useGetFormConfig(props);
  const {
    placeholder, disabled, showSearch, mode, onChange: onChangeFromOrigin, onClear: onClearOrigin, onSearch: onSearchOrigin,
    defaultValue, key, allowClear, onlyAlphaNumeric, fieldLengthValue, dataTestname, dataTestDrop, maxLengthValue, onFocus, onBlur,
  } = formConfig;

  const { options = [] } = formConfig;
  const onSearch = (event: any): void => {
    let validStr = convertToValidStr(event);
    if (onlyAlphaNumeric) {
      validStr = validStr.replace(ONLY_ALPHA_NUMERIC, '');
    }
    setSearchValue(maxLengthValue ? validStr.slice(0, fieldLengthValue[0]) : validStr?.length >= MAX_CHARACTERS_LIMIT ?
      validStr.slice(0, MAX_CHARACTERS_LIMIT) : validStr);
    if (onSearchOrigin) {
      onSearchOrigin(validStr);
    }
  };

  const onChange = (opt: any, event: any): void => {
    setSearchValue('');
    setExtraRules([]);
    if (onChangeFromOrigin) {
      onChangeFromOrigin(opt, event);
    }
  };

  const onClear = (): void => {
    if (onClearOrigin) {
      onClearOrigin();
    }

  };

  return <FormItem formConfig={formConfig} extraRules={[...extraRules]}>
    <Select
      allowClear={allowClear}
      data-testid={key}
      defaultValue={defaultValue}
      disabled={disabled}
      showSearch={(onSearchOrigin === true || onSearchOrigin === false) ? onSearchOrigin : showSearch}
      placeholder={placeholder}
      mode={mode}
      onChange={(option: any, ev: any): void => onChange(option, ev)}
      onClear= {onClear}
      onSearch={(event: any): any => onSearch(event)}
      optionFilterProp="children"
      searchValue={searchValue}
      onBlur={(): void => onBlur && onBlur()}
      onFocus={(): void => onFocus && onFocus()}
      >
      {
        options?.map((option: any): ReactElement => {
          let name = option;
          let value = option;
          if (option.value && option.name) {
            name = option.name;
            value = option.value || option.name;
          }
          return (
          !option?.disabled ?
          <Option key={value} value={value} title={name} data-testid={`${key}-${value}`}
           data-testname={dataTestname || ''} data-dropdown = {dataTestDrop || ''}>
            {
               name
            }
          </Option> :
          <Option className="clr-disabled mouse-not-allowed" key={value} value={value} title={name} data-testid={`${key}-${value}`}>
            {name}
          </Option>

          );
        })
      }
    </Select>
  </FormItem>;
};

export default FormSelect;
